import { useEffect } from "react";
import { useLocation } from "react-router";
import {
  bootstrapPrivacySignals,
  COOKIE_CONSENT_EVENT,
  hasAnalyticsConsent,
} from "@/lib/cookieConsent";
import {
  loadGoogleAnalytics,
  setAnalyticsConsentGranted,
  trackPageView,
} from "@/lib/googleAnalytics";
import { loadMicrosoftClarity, setClarityConsent } from "@/lib/microsoftClarity";

const gaMeasurementId = (import.meta.env.VITE_GA_MEASUREMENT_ID ?? "").trim();
const clarityProjectId = (import.meta.env.VITE_CLARITY_PROJECT_ID ?? "").trim();

function syncMarketingAnalytics(): void {
  const consented = hasAnalyticsConsent();

  if (!consented) {
    if (gaMeasurementId) setAnalyticsConsentGranted(false);
    if (clarityProjectId) setClarityConsent(false);
    return;
  }

  if (gaMeasurementId) {
    void loadGoogleAnalytics(gaMeasurementId).then(() => {
      trackPageView(`${window.location.pathname}${window.location.search}`);
    });
  }
  if (clarityProjectId) {
    loadMicrosoftClarity(clarityProjectId);
    setClarityConsent(true);
  }
}

/** Loads GA4 and Microsoft Clarity only after Essential or Accept all (not after Reject). */
export function MarketingAnalytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    bootstrapPrivacySignals();
    syncMarketingAnalytics();
    const onConsent = () => syncMarketingAnalytics();
    window.addEventListener(COOKIE_CONSENT_EVENT, onConsent);
    return () => window.removeEventListener(COOKIE_CONSENT_EVENT, onConsent);
  }, []);

  useEffect(() => {
    if (!gaMeasurementId || !hasAnalyticsConsent()) return;
    trackPageView(`${pathname}${search}`);
  }, [pathname, search]);

  return null;
}
